import { useEffect } from 'react'

import { sortArrayBy } from '@domain-group/javascript-utils'

import { Form } from '@domain-group/suit-theme'

import { UseFormPayload, useSetState } from '@domain-group/react-hooks'

import search from '@functions/search'

import type { AgencyModel } from '@models/types'

const defaultState = {
  agencies: [] as AgencyModel[],
}

type SetState = (state: Partial<typeof defaultState>) => void

const fetchAgencies = async (setState: SetState) => {
  // @ts-expect-error TS2339
  const { success, data } = await search('', { agency_collaborators: true }, '/agencies')
  // @ts-expect-error TS2322
  if (success) setState({ agencies: data })
}

interface MarketingAgencySelectorProps {
  campaignForm: UseFormPayload,
}

const MarketingAgencySelector = (props: MarketingAgencySelectorProps) => {
  const { campaignForm: { entityState: { marketing_agency_id }, handlers } } = props

  const [state, setState] = useSetState(defaultState)
  const { agencies } = state

  useEffect(() => {
    fetchAgencies(setState)
  }, [])

  return (
    // @ts-expect-error TS2322
    <Form.Field label="Marketing" marginTop={['large', 0]}>
      {/*
       // @ts-expect-error TS2322 */}
      <select data-value-type="number" name="marketing_agency_id" value={marketing_agency_id} {...handlers}>
        <option value="">Campaign Owner</option>
        {agencies?.length && sortArrayBy(Object.values(agencies), 'asc', 'title').map(agency => (
          <option key={agency.id} value={agency.id}>
            {agency.title}
          </option>
        ))}
      </select>
    </Form.Field>
  )
}

export default MarketingAgencySelector
